import { getCompanyHubEditorRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { HubEditorRoute } from './HubEditorRoute.tsx';
import type { RouteWithNavParamsType } from '@confluence/ssr-app/entry-points/routes.ts';

export const CompanyHubEditorRoute: RouteWithNavParamsType =
	getCompanyHubEditorRoute(HubEditorRoute);
